<div #toastElement class="toast align-items-center" [class]="toastClass()" role="alert" aria-live="assertive" aria-atomic="true">
  <div class="d-flex">
    <div class="toast-body">
      {{toast().text}}
    </div>

    @if (toast().ongoing) {
      <div class="spinner-border spinner-border-sm me-2 m-auto flex-shrink-0"></div>
    } @else {
      <button type="button" class="btn-close me-2 m-auto flex-shrink-0" data-bs-dismiss="toast" aria-label="Close"></button>
    }
  </div>
</div>
